<div class="p-l-5 p-r-2 p-t-1">
    <ul class="overflow-y-auto custom-scrollbar p-r-2"
        style="max-height: 100vh;">
        @for (item of items | orderBy : ['data.added_at'] : ['desc']; track trackByItemId($index, item); let
        last = $last; let first = $first) {
        <li [ngClass]="{'b-b':!last}">
            <minibasket-item class="w-12"
                             [noCustomOps]="true"
                             [item]="item" />
        </li>
        }
    </ul>
</div>

<div class="p-l-5 p-r p-b-5">
    <reward-banner class="block m-t-3" />
    <coupon-form class="block m-t-3" />
    <giftcards-form *ifNotTradeStore
                    class="block m-t-3" />
    <basket-view-totals class="block" />
</div>